import React from 'react';
import { PageHeader } from '../../../components/layout/Header';
import { Button } from '../../../components/ui/Button';
import FollowUpTabs from './components/FollowUpTabs';
import FollowUpListTab from './components/FollowUpListTab';
import FollowUpParamsTab from './components/FollowUpParamsTab';
import FollowUpHistoryTab, { FollowUpStatusKpi } from './components/FollowUpHistoryTab';
import FollowUpFormSheet from './components/FollowUpFormSheet';
import { useFollowUpPage } from './hooks/useFollowUpPage';

const FollowUpSettings: React.FC = () => {
    const {
        activeTab,
        setActiveTab,
        templates,
        loading,
        saving,
        remove,
        duplicate,
        toggleActive,
        updateDelay,
        expandedId,
        toggleExpand,
        inlineMessage,
        setInlineMessage,
        inlineMediaUrl,
        setInlineMediaUrl,
        isSheetOpen,
        editingTemplate,
        openCreateSheet,
        openEditSheet,
        closeSheet,
        handleSheetSave,
        destinationRows,
        history,
        openHistory,
    } = useFollowUpPage();

    return (
        <main className="flex min-h-0 flex-col bg-background">
            <header className="mb-s4 md:mb-s6">
                <PageHeader
                    title="Follow-up"
                    subtitle="Mensagens automáticas para reativar leads no funil"
                    hideBackButton
                    titleClassName="text-lg font-semibold tracking-tight text-default md:text-xl"
                    subtitleClassName="text-sm text-muted"
                    className="mb-0 gap-s3"
                    action={
                        activeTab === 'followups' ? (
                            <Button
                                type="button"
                                onClick={openCreateSheet}
                                disabled={saving}
                                className="min-h-11 touch-manipulation md:min-h-0"
                            >
                                Novo follow-up
                            </Button>
                        ) : undefined
                    }
                />
            </header>

            <FollowUpStatusKpi
                counts={history.counts}
                activeStatus={activeTab === 'history' ? history.status : null}
                onSelect={openHistory}
            />

            <FollowUpTabs activeTab={activeTab} onChange={setActiveTab} />

            {activeTab === 'followups' && (
                <FollowUpListTab
                    templates={templates}
                    loading={loading}
                    saving={saving}
                    onAdd={openCreateSheet}
                    onEdit={openEditSheet}
                    onRemove={remove}
                    onDuplicate={duplicate}
                    onToggleActive={toggleActive}
                    onUpdateDelay={updateDelay}
                    expandedId={expandedId}
                    onToggleExpand={toggleExpand}
                    inlineMessage={inlineMessage}
                    onInlineMessageChange={setInlineMessage}
                    inlineMediaUrl={inlineMediaUrl}
                    onInlineMediaChange={setInlineMediaUrl}
                    destinationRows={destinationRows}
                />
            )}

            {activeTab === 'params' && <FollowUpParamsTab />}

            {activeTab === 'history' && (
                <FollowUpHistoryTab
                    status={history.status}
                    startDate={history.startDate}
                    setStartDate={history.setStartDate}
                    endDate={history.endDate}
                    setEndDate={history.setEndDate}
                    rows={history.rows}
                    loading={history.loading}
                    refresh={history.refresh}
                />
            )}

            <FollowUpFormSheet
                isOpen={isSheetOpen}
                onClose={closeSheet}
                onSave={handleSheetSave}
                template={editingTemplate}
            />
        </main>
    );
};

export default FollowUpSettings;
